import Ride, { RideType } from "./Ride";
import TimeOfDay from "./TimeOfDay";
import Passenger from "@/components/Passenger/models/Passenger";
import moment from 'moment';

export class WeekDay {
    
    id: number;
    name: string;
    weekend: boolean;
    enabled: boolean;
    
    constructor(id: number, name: string, weekend: boolean = false, enabled: boolean = true) {
        this.id = id;
        this.name = name;
        this.weekend = weekend;
        this.enabled = enabled;
    }

    public static nextWeekDayId(id: number) {
        return id < 6 ? id + 1 : 0;
    }

    public static WeekDays(weekStartsOnSunday: boolean, startDate: Date, endDate: Date): WeekDay[] {
        const sunday: WeekDay = new WeekDay(0, "Sunday", true);
        const days: WeekDay[] = [
            new WeekDay(1, "Monday"),
            new WeekDay(2, "Tuesday"),
            new WeekDay(3, "Wednesday"),
            new WeekDay(4, "Thursday"),
            new WeekDay(5, "Friday"),
            new WeekDay(6, "Saturday", true)
        ]
        if (weekStartsOnSunday) {
            days.unshift(sunday);
        } else {
            days.push(sunday);
        }

        // set weekday.enabled to false if not in range
        const startMoment = moment(startDate);
        const endMoment = moment(endDate);
        const diffDays = Math.abs(startMoment.diff(endMoment, "days"));
        const dayNumbersInRange = [];
        if (diffDays < 7){
            // if the diffDays span is < 7 days, some days need disabling
            dayNumbersInRange.push(startMoment.isoWeekday());
            for (const deltaDay of  [...Array(diffDays + 1).keys()].slice(1)) {
                dayNumbersInRange.push(moment(startDate).add(deltaDay, "days").isoWeekday());
            }
            // dayNumbersInRange contains ISO weekday numbers of included days
            // let's set .enabled for each day
            // the ones not in the range will then have .enabled = false
            days.forEach(d => {
                d.enabled = dayNumbersInRange.includes(d.id); 
            });
        }
        
        return days;
    }
    
}

export default WeekDay;
